/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Architect_Detail9Inputs */

const en_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel setup, templates, payments and CRM wiring.`)
};

const ar_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعداد القنوات والقوالب والمدفوعات وربط CRM.`)
};

const bn_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চ্যানেল সেটআপ, টেমপ্লেট, পেমেন্ট আর CRM সংযোগ।`)
};

const de_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal-Setup, Vorlagen, Zahlungen und CRM-Anbindung.`)
};

const es_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de canales, plantillas, pagos e integración con el CRM.`)
};

const fr_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration des channels, templates, paiements et branchement CRM.`)
};

const pt_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração de channels, templates, pagamentos e ligação ao CRM.`)
};

const zh_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渠道配置、模板、支付和 CRM 对接。`)
};

const tr_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal kurulumu, şablonlar, ödemeler ve CRM bağlantısı.`)
};

const ru_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение каналов, темплейты, платежи и интеграция с CRM.`)
};

const pl_svc_messaging_bots_architect_detail9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguracja channeli, templatki, płatności i integracja z CRM.`)
};

/**
* | output |
* | --- |
* | "Channel setup, templates, payments and CRM wiring." |
*
* @param {Svc_Messaging_Bots_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_architect_detail9 = /** @type {((inputs?: Svc_Messaging_Bots_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "de") return de_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "es") return es_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_architect_detail9(inputs)
	return en_svc_messaging_bots_architect_detail9(inputs)
});
export { svc_messaging_bots_architect_detail9 as "svc_messaging-bots_ARCHITECT_detail" }